import React from 'react';
import styled from '@nykaa/ui-components/styles/styled';
import getFontData from './helper';
import { defaultTranslationKeys, FONT_NORMAL } from '../constants';
const PriceInfo = styled.div `
  line-height: 20px;
  margin-bottom: ${({ theme }) => theme.spacing.spacing20};
`;
const MrpInfo = styled.span `
  margin-right: 4px;
  color: ${({ theme }) => theme.colors.textSecondary};
  ${(props) => getFontData(props)};
  span {
    text-decoration-line: line-through;
    padding-left: 3px;
    ${(props) => getFontData(props, FONT_NORMAL)};
  }
`;
const OfferPrice = styled.span `
  color: ${({ theme }) => theme.colors.textPrimary};
  ${(props) => getFontData(props, props.kind)};
`;
const Discount = styled.span `
  color: ${({ theme }) => theme.colors.positive};
  margin-left: 4px;
  padding-left: 4px;
  border-left: 1px solid #eeeeee;
  ${(props) => getFontData(props, FONT_NORMAL)};
`;
const OfferPriceWrapper = styled.div `
  margin-bottom: ${({ theme: { spacing } }) => spacing.spacing20};
`;
const CardPrice = ({ mrp, price, discount, size, discountTranslation = defaultTranslationKeys.discount, }) => {
    const DEFAULT_SIZE = 'default';
    const translation = `${discount}% ${discountTranslation}`;
    if (price && (mrp > price)) {
        return (React.createElement(PriceInfo, null,
            React.createElement(MrpInfo, { size: DEFAULT_SIZE },
                React.createElement("span", null, `₹${mrp}`)),
            React.createElement(OfferPrice, { size: DEFAULT_SIZE }, `₹${price}`),
            (discount > 0) && (React.createElement(Discount, { size: DEFAULT_SIZE }, translation))));
    }
    return (React.createElement(OfferPriceWrapper, null,
        React.createElement(OfferPrice, { size: size, kind: FONT_NORMAL }, `₹${mrp}`)));
};
export default CardPrice;
